module.exports = __webpack_public_path__ + "static/img/bgNews.ef5dc73c.png";